import { useCallback, useEffect } from 'react';
import { isFunction } from 'lodash';
import { store } from '../redux';
import eventBus from './eventBus';
import { SCANNER_EVENT } from './useBarcodeScanner';

const checkIsBlockScannerGlobally = () => {
  const state = store.getState();
  return state?.expiryLogin?.isOpen ?? false;
};

const useBarcodeListener = (handler, controller) => {
  const barcodeHandler = useCallback(
    (e) => {
      isFunction(handler) && !checkIsBlockScannerGlobally() && handler(e);
    },
    [handler]
  );

  const onListener = useCallback(() => {
    eventBus.on(SCANNER_EVENT, barcodeHandler);
  }, [barcodeHandler]);

  const offListener = useCallback(() => {
    eventBus.off(SCANNER_EVENT, barcodeHandler);
  }, [barcodeHandler]);

  useEffect(() => {
    controller && onListener();

    return () => offListener();
  }, [barcodeHandler, controller]);
};

export default useBarcodeListener;
